import { useEffect, useState } from 'react';
import { getProxyOrderRoomPageListByPreset, } from '../../service/storeRevenueApi';
export function useOrderRoomPresetData(storeId, preset, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(enabled), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), tick = _d[0], setTick = _d[1];
    useEffect(function () {
        if (!enabled) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        getProxyOrderRoomPageListByPreset(storeId, preset)
            .then(function (res) {
            if (!cancelled)
                setData(res);
        })
            .catch(function (e) {
            if (!cancelled) {
                setData(null);
                setError(e instanceof Error ? e : new Error(String(e)));
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, preset, tick, enabled]);
    return {
        data: data,
        loading: loading,
        error: error,
        reload: function () { return setTick(function (n) { return n + 1; }); },
    };
}
